import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import classNames from "classnames";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import {
  FormattedMessage,
  IntlProvider,
} from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { instance } from "../../../Actions/AxiosInstance";
import {
  ValidateAction,
  ValidateReqField,
  ValidateReqFields,
} from "../../../Utils/Validation";
import createstore from "../../../store";
import SucessLogo from "../../../Assets/Images/forgotPwdSuccess.png";
import { ChangeLanguage } from "../../../Actions/LanguageAction";
import "../../SignUp/LeadSignup/LeadSignup.css";
import "../Login.css";
import "./index.css";
import { getFormattedImageLink, getFormattedLogoLink } from "../../../Utils";

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    height: 56,
  },
  leadloginbutton: {
    width: 200,
    height: 56,
  },
  padding30: {
    padding: 30,
  },
  root: {
    flexGrow: 1,
  },
});

class SubscriptionForgotPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      subdomain: window.location.hostname,
      amount: "",
      password: "",
      flag: 1,
      showPassword: false,
      checkedA: true,
      checkedB: true,
      fields: {
        emailid: "",
      },
      reqFields: {
        emailid: "",
      },
      errors: {},
      helperText: {},
      submitButton: true,
      SubscriptionDetails: {},
    };
  }

  // componentDidMount() {
  //     let subdomain = this.state.subdomain.split('.')
  //     subdomain = subdomain[0]
  //     this.props.VerifySubscription(subdomain)
  // }
  componentWillMount() {
    this.props.ChangeLanguage("subscriptionforgotpassword");
    const { SubscriptionInfo } = createstore.getState();
    const SubscriptionDetails = SubscriptionInfo.SubscriptionData;
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    this.setState({ SubscriptionDetails, accountid, subscriptionid });
  }

  handleResetPasswodValidation = () => {
    if (!this.Validate()) {
      this.props.enqueueSnackbar("Please fill all the required fields", {
        variant: "error",
      });
    } else {
      this.setState({ CommonError: "" });
      const URL = "subscription/resetpasswordrequest";
      let subdomain = this.state.subdomain.split(".");
      subdomain = subdomain[0];
      const data = {
        emailid: this.state.fields.emailid,
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        subdomain,
        // "emailid":"xokaru@hiltonvr.com",
        // "accountid":420,
        // "subscriptionid":417
      };
      instance
        .post(URL, data)
        .then((result) => {
          this.setState({ flag: 2 });
        })
        .catch((error) => {
          this.setState({ flag: 2 });
          // this.setState({ CommonError: error.response.data.error.message })
        });
    }
  };

  SetHelperTextFlag(field, e) {
    const { helperText } = this.state;
    helperText[field] = true;
    this.setState({ helperText });
  }

  OnFieldChange(field, type, e) {
    const { fields } = this.state;
    fields[field] = e.target.value ? e.target.value : "";
    this.setState({ fields });
    ValidateAction(this.state, field, type);
  }

  ValidateField(reqField, type, e) {
    const { reqFields } = this.state;
    reqFields[reqField] = e.target.value ? e.target.value : "";
    this.setState({ reqFields });
    if (ValidateAction(this.state, reqField, type)) {
      ValidateReqField(this.state, reqField, type);
    }
  }

  Validate() {
    let formIsValid = true;

    if (!ValidateReqFields(this.state)) {
      formIsValid = false;
    }
    return formIsValid;
  }

  render() {
    const { classes } = this.props;
    const setflag = this.state.flag;
    const language = this.props.Language.subscriptionforgotpassword;
    let model;
    if (setflag === 1) {
      model = (
        <div
          style={{
            height: "88vh",
            display: "table",
            width: "60%",
            margin: "0 auto",
          }}
        >
          <form className="lead-signup-form1 roleselect">
            <div className="sucesslogo">
              <div className="hello-welcome">
                <FormattedMessage id="LbOps" defaultMessage="Oops! Its OK." />
              </div>
              <FormattedMessage
                id="__LbLetusset"
                defaultMessage="Let us set a rememberable password or <a href='/login'>Login </a> instead."
              />
              <div className="input-div">
                <p className="input-form-label">
                  <span>Work e-mail</span>
                </p>
                <TextField
                  id="email"
                  type="emailid"
                  className={classNames(classes.dense, "width100")}
                  margin="dense"
                  variant="outlined"
                  placeholder="kuber@abacus.company"
                  onFocus={this.SetHelperTextFlag.bind(this, "emailid")}
                  onChange={this.OnFieldChange.bind(this, "emailid", "email")}
                  onBlur={this.ValidateField.bind(this, "emailid", "email")}
                  error={!!this.state.errors.emailid}
                  maxLength="10"
                />
                {!!this.state.errors.emailid &&
                !this.state.helperText.emailid ? (
                  <span className="caption-error">
                    <FormattedMessage
                      id="__Erworke-mail"
                      defaultMessage="Are you sure you've entered a correct email?"
                    />
                  </span>
                ) : (
                  ""
                )}
                {this.state.helperText.emailid ? (
                  <span className="caption-helptest">
                    <FormattedMessage
                      id="Htworke-mail"
                      defaultMessage="The email you used during signup goes here 🔒"
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
              <div className="Forgot-pass-button margin-top-30">
                <Button
                  variant="contained"
                  color="primary"
                  className="leadloginbutton"
                  onClick={this.handleResetPasswodValidation}
                >
                  <FormattedMessage id="BtSubmit" defaultMessage="SUBMIT" />
                </Button>
              </div>
              <span className="caption-error">{this.state.CommonError}</span>
            </div>
          </form>
        </div>
      );
    } else if (setflag === 2) {
      model = (
        <div
          style={{
            height: "88vh",
            display: "table",
            width: "60%",
            margin: "0 auto",
          }}
        >
          <div className="lead-signup-form1">
            <div className="sucesslogo">
              <img
                src={SucessLogo}
                height="300px"
                alt="logo"
                className="forgot-pwd-img"
              />
              <p align="center" className="sucessmessage padding-bottom-20">
                <FormattedMessage
                  id="LbYouwillreceive"
                  defaultMessage=" You will receive an email with a unique link to reset your account at"
                />
                &nbsp;
                {this.state.fields.emailid}
              </p>
            </div>
          </div>
        </div>
      );
    }
    return (
      <IntlProvider locale="en" messages={language}>
        <div className="loginbg subscriptionlogin-page width100">
          <div className={classes.root}>
            <Grid container>
              <Grid item xs={12} md={6} sm={12} className="leadloginformdiv">
                <div>
                  <div align="center" className="logo">
                    <img
                      src={getFormattedLogoLink(
                        this.state.SubscriptionDetails.logo,
                      )}
                      style={{ maxHeight: 60, maxWidth: 200 }}
                      alt="logo"
                    />
                  </div>
                  {model}
                </div>
              </Grid>
              <Grid item xs={12} md={6} sm={12}>
                <div className="win-height position-rel">
                  {this.state.SubscriptionDetails.bgimage ? (
                    <div style={{ height: "100vh" }}>
                      <div
                        className="applogin-bgimg1 "
                        style={{ height: "100vh" }}
                      >
                        <img
                          src={getFormattedImageLink(
                            this.state.SubscriptionDetails.bgimage,
                          )}
                          width={"100%"}
                          height={"100%"}
                          style={{ objectFit: "cover" }}
                        ></img>
                      </div>
                      <div className="applogin-cont">
                        <div className="HRMSimplified">
                          {this.state.SubscriptionDetails.headertext
                            ? this.state.SubscriptionDetails.headertext
                            : "HRMSimplified"}
                        </div>
                        <div>
                          <React.Fragment>
                            {this.state.SubscriptionDetails.subheadertext ? (
                              <p className="simplifided-slogan padding-top-30">
                                {this.state.SubscriptionDetails.subheadertext}
                              </p>
                            ) : (
                              <p className="simplifided-slogan padding-top-30">
                                Save your money for Growth, Use your time for
                                Relationships.
                              </p>
                            )}
                          </React.Fragment>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="HRMSimplified-div">
                      <div className="applogin-cont">
                        <div className="HRMSimplified">
                          {this.state.SubscriptionDetails.headertext
                            ? this.state.SubscriptionDetails.headertext
                            : "HRMSimplified"}
                        </div>
                        <div className="simplifided-slogan">
                          {this.state.SubscriptionDetails.subheadertext ? (
                            this.state.SubscriptionDetails.subheadertext
                          ) : (
                            <p className="simplifided-slogan padding-top-30">
                              Save your money for Growth, <br /> Use your time
                              for Relationships.
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </IntlProvider>
    );
  }
}

SubscriptionForgotPassword.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(SubscriptionForgotPassword)));
